import Err from "@Client/@Routes/error";
import { DOCUMENTS_ADDED_NOTIFICATION, LOAD_LENDER_DATA } from "@Client/@Modules/main/store/account/account-actions";
export const SOCKET_MESSAGE = "SOCKET_MESSAGE";
const WebsocketEventsToActionMap = {
  DOCUMENTS_ADDED: `AccountStore/${LOAD_LENDER_DATA}`
};
const WebsocketEventsToNotificationMap = {
  DOCUMENTS_ADDED: {
    action: `AccountStore/${DOCUMENTS_ADDED_NOTIFICATION}`,
    message: "Additional documents are available for you to download.",
    type: "info"
  }
};
const actions = {
  [SOCKET_MESSAGE]: async (context, {
    event,
    data
  }) => {
    const actionToCall = WebsocketEventsToActionMap[event];
    const notificationToCall = WebsocketEventsToNotificationMap[event];
    try {
      if (actionToCall) {
        context.dispatch(actionToCall, {
          urlId: data.urlId,
          offset: data.offset
        }, {
          root: true
        });
      }
      if (notificationToCall) {
        context.dispatch(notificationToCall.action, {
          data,
          notification: notificationToCall
        }, {
          root: true
        });
      }
    } catch (e) {
      Err.handle(e, {});
    }
  }
};
export default actions;